import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {ModalidadTasa} from '../_models/modalidad-tasa';

@Injectable({
  providedIn: 'root'
})
export class ModalidadTasaService {

  private rutServicioModalidad = AppSettings.rutServiciosAPL + '/api/modalidadesTasas';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listadoModalidadesTasas() {
    return this.httClient.get( this.rutServicioModalidad ).pipe( map( res => res as ModalidadTasa[] ) );
  }

  listadoModalidadesTasasHabilitadas() {
    return this.httClient.get( this.rutServicioModalidad + '/enabled' ).pipe( map( res => res as ModalidadTasa[] ) );
  }

  listadoModalidadesTasasIdModalidad(id: string) {
    return this.httClient.get( this.rutServicioModalidad + '/modalidad/' + id ).pipe( map( res => res as ModalidadTasa[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicioModalidad + '/' + id ).pipe( map( res => res as ModalidadTasa ) );
  }

  crear( modalidadTasa: ModalidadTasa ) {
    modalidadTasa.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicioModalidad, modalidadTasa ).pipe( map( res => res as ModalidadTasa ) );
  }

  actualizar( modalidadTasa: ModalidadTasa ) {
    modalidadTasa.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicioModalidad, modalidadTasa ).pipe( map( res => res as any ) );
  }

  bulk( modalidadesTasas: ModalidadTasa[] ) {
    modalidadesTasas.map(x => {
      x.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    })
    return this.httClient.post( this.rutServicioModalidad + '/bulk', modalidadesTasas ).pipe( map( res => res as ModalidadTasa[] ) );
  }

}
